
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paint-disposal/[city]",
      function () {
        return require("private-next-pages/paint-disposal/[city].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paint-disposal/[city]"])
      });
    }
  